import gql from 'graphql-tag'
import { EntityFields, EnumFields } from '..'

export const AgreementTypeFragment = gql`
  fragment AgreementType on settings_agreement_type{
    ${EntityFields}
    ${EnumFields}
  }
`
